<!-- 库房列表 -->
<template>
	<div class='page_content'>
		<div class="page_content_top">
			<div class="page_content_top_line">
				<el-button type="primary"  size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
					{{buttonValue.jurName}}
				</el-button>
				<el-button type="primary" icon="el-icon-refresh"  size="mini" @click="getDataList()" >
					刷新
				</el-button>
			</div>
			<div class="page_content_top_line">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline">
					<el-form-item label="预警名称">
						<el-input v-model.trim="getRequestData.wsName"  size="mini"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table size="mini" stripe :data="returnData.list"  @selection-change="selecDataAction" height="100%" border  style="width: 100%" highlight-current-row>
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column  type="index"  width="50" label="编号">
				</el-table-column>
				<el-table-column prop="wsName" label="预警名称">
				</el-table-column>
				<el-table-column prop="wsCode" label="预警编码">
				</el-table-column>
				<el-table-column prop="wsDays" label="预警天数" >
				</el-table-column>
				<el-table-column prop="wsState" label="	状态" >
					<template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.wsState == 0" type="danger">否</el-tag size="mini">
                        <el-tag size="mini" v-if="scope.row.wsState == 1" type="success">是</el-tag size="mini">
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<el-pagination
				background
				@size-change="setDataPageSize"
				@current-change="setDataPageNumber"
				:current-page="getRequestData.page"
				:page-sizes="[30,50,100,500]"
				:page-size="30"
				layout="total, sizes, prev, pager, next, jumper"
				:total="returnData.total">
			</el-pagination>
		</div>
		<!-- 数据操作窗口 -->
		<el-drawer :close-on-press-escape="true"  
			:visible.sync="dataActionBox.showStatus" 
			:with-header="false" 
			:append-to-body="true"
			custom-class="drawer_box"
			:direction="dataActionBox.openMode" size="50%">
			<div class="demo-drawer__content data_action_form">
				<div class='data_page_content'>
					<div class="page_title">
						<el-alert :title="dataActionBox.boxTitle" type="success" effect="dark" :closable="false">
						</el-alert>
					</div>
					<div class="page_form_box">
						<el-form ref="form" :model="sendDataInfo" label-width="120px" :rules="rules">
							<el-form-item label="预警名称">
								<el-input v-model.number="sendDataInfo.wsName" :maxlength="$store.state.inputLength"></el-input>
							</el-form-item>
							<el-form-item label="预警编码">
								<el-input v-model.trim="sendDataInfo.wsCode" :maxlength="$store.state.inputLength"></el-input>
							</el-form-item>
							<el-form-item label="预警天数">
								<el-input v-model.number="sendDataInfo.wsDays" :maxlength="$store.state.inputLength"></el-input>
							</el-form-item>
							
							<el-form-item label="是否可出库">
								<el-radio-group v-model="sendDataInfo.wsState" size="small">
								    <el-radio-button :label="0">停用</el-radio-button>
								    <el-radio-button :label="1">启用</el-radio-button>
								</el-radio-group>
							</el-form-item>
							
							<el-form-item>
								<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
								<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
							</el-form-item>
						</el-form>
					
					</div>
				</div>
				
			</div>	
				
		</el-drawer>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
	
			dataActionBox:{
				showStatus:false,
				openMode:'ltr'||'rtl',
				boxTitle:'',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo: {
				wsCode: '',  // 	预警编码
				wsDays:0,   // 预警天数
				wsId:0,   // 	预警id
				wsName:'',   // 预警名称
				wsState:'',   //	状态
			},
			selectedDataList:[],
			rules: {
				stName: [
					{ required: true, message: '请输入预警名称', trigger: 'blur' },
				],
			},
			buttonList:[],
			getRequestData:{
				wsName:'',
				start:'',
				end:'',
				page:1,
				rows:30,
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {
		// 修改状态
		async setDataAction(){
			if(this.selectedDataList.length<1){
				this.$message({
					message: '请先选择您要操作的数据',
					type: 'error'
				});
				return false
			}
			
			if(this.selectedDataList.length>1){
				this.$message({
					message: '只能选择一条数据进行操作，请勿多选',
					type: 'error'
				});
				return false
			}
			var  dataInfo = this.selectedDataList[0]
			var sendData = {
				ids:[dataInfo.stId]
			}
			let responseData =  await this.$http.setWarningSettingStatus(sendData)
			if(responseData.status == 200){
				this.$message({
					type: 'success',
					message: '操作成功!'
				});
				this.getDataList()
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
			
		},
		
		selecDataAction(data){
			this.selectedDataList =  data
		},
		openActionBox(cate){
			this.initActionBox()
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增信息'
				this.dataActionBox.openMode = 'ltr'
			}else{
				this.dataActionBox.boxTitle = '编辑信息'
				this.dataActionBox.openMode = 'rtl'
				if(this.getDataDateils() == false){
					return false
				}
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
		},
		
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			
			this.dataActionBox.actionType = 0
			this.dataActionBox.showStatus = false
		},
		
		// 获取数据详情
		getDataDateils(){
			if(this.selectedDataList.length<1){
				this.$message({
					message: '请先选择您要修改的数据条目',
					type: 'error'
				});
				return false
			}
			
			if(this.selectedDataList.length>1){
				this.$message({
					message: '编辑信息只能选择一条数据，请勿多选',
					type: 'error'
				});
				return false
			}
			var  dataInfo = this.selectedDataList[0]
			for(let key in dataInfo){
				this.sendDataInfo[key]  = dataInfo[key]
			}
		
			return true
		},
		// 动作集合
		actionSet(actionData){
			switch(actionData.actionType){
				case 0:
					this.openActionBox(actionData.actionType)
					break;
				case 1:
					this.openActionBox(actionData.actionType)
					break;
				case 2:
					this.delDataAction()
					break;
				case 3:
					this.setDataAction()
					break;
			}
		},
		async getButtonList(){
			this.buttonList = await this.$common.getActionButton()
		},
	
		
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		
		// 发送数据
		async sendDataAction(){
			if(this.sendDataInfo.stName	==''){
				this.$message({
					message: '请填写库房名称',
					type: 'error'
				});
				return false
			}
			if(this.sendDataInfo.ormId==''){
				this.$message({
					message: '请选择归属组织',
					type: 'error'
				});
				return false
			}
			
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.addStorageRoom(this.sendDataInfo)
			}else{
				var responseData =  await this.$http.setWarningSetting(this.sendDataInfo)
			}
			if(responseData.status == 200){
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				var _this = this
				if(this.dataActionBox.actionType==0){
					this.setDataPageNumber(1)
				}else{
					this.getDataList()
				}
				
				this.initActionBox()
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
				
				
			}
		},
		
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getWarningSetting(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getDataList()
		this.getButtonList()
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>

</style>
